import React, { useContext } from "react";
import { useState, useEffect } from "react";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./ViewOffCanvance.css";
import { Context } from "../../../utils/context";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import "react-phone-input-2/lib/bootstrap.css";
import Select from "react-select";
import { CancelButton, SaveButton } from "../../common/Button";
import ModalSave from "../../common/ModelSave";
import { Modal } from "react-bootstrap";

library.add(fas);

const ViewOffCanvance = (props) => {
  const [value, setValue] = React.useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [previewImage, setPreviewImage] = React.useState(null);
  const [showImageModal, setShowImageModal] = React.useState(false);

  const handleImageClick = (img) => {
    setPreviewImage(img);
    setShowImageModal(true);
  };

  const handleCloseImageModal = () => {
    setShowImageModal(false);
    setPreviewImage(null);
  };

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    getValues,
  } = useForm();

  const onSubmit = async (data) => {
    if (!data?.stage?.value) return; // stops API call

    try {
      const dataToSend = new FormData();
      dataToSend.append("stage", data?.stage?.value);
      const response = await postData(
        `/delivery-boy-manegement/delivery-boy/updateStatus/${props.id}`,
        dataToSend,
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        // setShowModal(0);
        setShowModal({ code: 0, message: "" });
        props.handleClose();
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error(error);
    }
  };

  const [data, setData] = useState();
  const getSellerData = async () => {
    const res = await getData(
      `/delivery-boy-manegement/delivery-boy/${props.id}`,
    );
    setData(res.data);
    reset(res.data);
  };

  useEffect(() => {
    getSellerData();
  }, [props.id]);

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%", height: "auto" }}
        placement={"end"}
        onHide={props.handleClose}
        className="offcan"
      >
        <Container fluid className="tabss-main">
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <Offcanvas.Body>
            <Card className="shadow-lg p-3 mb-5 bg-white rounded">
              <Card.Body>
                <Card.Title>
                  <h3>Delivery boy Details </h3>
                </Card.Title>

                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value} className="main-tab">
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                        className="main-tab"
                      >
                        <Tab label="Personal Details" value="1" />
                        <Tab label="Kyc Details" value="2" />
                        {/* <Tab label="Certification Details" value="3" />
                        <Tab label="Documents Details" value="4" />
                        <Tab label="Bank Details" value="5" />
                        <Tab label="Commission And OnBoarding" value="7" />
                        <Tab label="On Boarding Payment Form" value="8" />
                        <Tab label="Mou Document" value="6" /> */}
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <div>
                        <div>
                          <h5>
                            {" "}
                            <b>Personal Details</b>
                          </h5>
                        </div>

                        <div>
                          <Row>
                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>First Name</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.first_name}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Contact Number</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.contact_no}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Email</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.email}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Vehicle No</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.vehicle_no}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            {/* <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Vehicle Rc No</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.vehicle_rc_no}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col> */}

                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Vehicle Licence No</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.vehicle_licence_no}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel value="2">
                      <div>
                        <div>
                          <h3>KYC Details</h3>
                        </div>

                        <div>
                          <Row>
                            <Col md={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Bank Name</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={
                                          data?.delivery_boy_kyc?.bank_name
                                        }
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Account Number</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={
                                          data?.delivery_boy_kyc?.account_number
                                        }
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>IFSC Code</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={
                                          data?.delivery_boy_kyc?.ifsc_code
                                        }
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                          <hr></hr>
                          <div>
                            <h3>Documents</h3>
                          </div>

                          <Row>
                            <Col md={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Aadhar Card</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      {data?.aadhar_card ? (
                                        <img
                                          src={IMG_URL + data?.aadhar_card}
                                          alt="Aadhar Card"
                                          style={{
                                            width: "100%",
                                            maxHeight: "200px",
                                            objectFit: "contain",
                                            border: "1px solid #ccc",
                                            borderRadius: "8px",
                                          }}
                                          onClick={() =>
                                            handleImageClick(
                                              IMG_URL + data?.aadhar_card,
                                            )
                                          }
                                        />
                                      ) : (
                                        "No Image"
                                      )}
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Pan Card</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      {data?.pan_card ? (
                                        <img
                                          src={IMG_URL + data?.pan_card} // replace with actual image URL key
                                          alt="Pan Card"
                                          style={{
                                            width: "100%",
                                            maxHeight: "200px",
                                            objectFit: "contain",
                                            border: "1px solid #ccc",
                                            borderRadius: "8px",
                                          }}
                                          onClick={() =>
                                            handleImageClick(
                                              IMG_URL + data?.pan_card,
                                            )
                                          }
                                        />
                                      ) : (
                                        "No Image"
                                      )}
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Driving Licence</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      {data?.driving_licence ? (
                                        <img
                                          src={IMG_URL + data?.driving_licence} // replace with actual image URL key
                                          alt="Driving Licence"
                                          style={{
                                            width: "100%",
                                            maxHeight: "200px",
                                            objectFit: "contain",
                                            border: "1px solid #ccc",
                                            borderRadius: "8px",
                                          }}
                                          onClick={() =>
                                            handleImageClick(
                                              IMG_URL + data?.driving_licence,
                                            )
                                          }
                                        />
                                      ) : (
                                        "No Image"
                                      )}
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Vehicle Image</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      {data?.vehicle_image ? (
                                        <img
                                          src={IMG_URL + data?.vehicle_image} // replace with actual image URL key
                                          alt="Vehicle Image"
                                          style={{
                                            width: "100%",
                                            maxHeight: "200px",
                                            objectFit: "contain",
                                            border: "1px solid #ccc",
                                            borderRadius: "8px",
                                          }}
                                          onClick={() =>
                                            handleImageClick(
                                              IMG_URL + data?.vehicle_image,
                                            )
                                          }
                                        />
                                      ) : (
                                        "No Image"
                                      )}
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            <Col md={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Vehicle RC Image</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      {data?.vehicle_rc_image ? (
                                        <img
                                          src={IMG_URL + data?.vehicle_rc_image}
                                          alt="Vehicle RC Image"
                                          style={{
                                            width: "100%",
                                            maxHeight: "200px",
                                            objectFit: "contain",
                                            border: "1px solid #ccc",
                                            borderRadius: "8px",
                                          }}
                                          onClick={() =>
                                            handleImageClick(
                                              IMG_URL + data?.vehicle_rc_image,
                                            )
                                          }
                                        />
                                      ) : (
                                        "No Image"
                                      )}
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </TabPanel>
                  </TabContext>
                </Box>
              </Card.Body>
            </Card>
          </Offcanvas.Body>
          <Col md={4}>
            <div className="main-form-section mb-3">
              <Row className="justify-content-center">
                <Form.Group>
                  <Form.Label>Take an action</Form.Label>
                  <InputGroup>
                    {/* <Controller
                      name="stage" // name of the field
                      control={control}
                      rules={{ required: "Take an Action" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.stage
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          options={[
                            {
                              value: "Approved",
                              name: "option",
                              label: "Approve",
                            },
                            {
                              value: "Rejected",
                              name: "option",
                              label: "Reject",
                            },
                          ]}
                        />
                      )}
                    /> */}

                    <Controller
                      name="stage"
                      control={control}
                      rules={{
                        validate: (val) =>
                          val?.value ? true : "Take an Action",
                      }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          value={field.value || null}
                          onChange={(selected) => field.onChange(selected)}
                          options={[
                            { value: "Approved", label: "Approve" },
                            { value: "Rejected", label: "Reject" },
                          ]}
                          placeholder="Select Action"
                          styles={{
                            control: (base) => ({
                              ...base,
                              borderColor: errors.stage
                                ? "red"
                                : base.borderColor,
                            }),
                          }}
                        />
                      )}
                    />
                  </InputGroup>
                  {errors.stage && (
                    <p style={{ color: "red" }}>{errors.stage.message}</p>
                  )}
                </Form.Group>
              </Row>
            </div>
          </Col>

          <div className="mt-5 pb-3">
            <div className="d-flex justify-content-center">
              <CancelButton name={"Back"} handleClose={props.handleClose} />

              <SaveButton name={"save"} handleSubmit={handleSubmit(onSubmit)} />
            </div>
          </div>
        </Container>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />

      <Modal
        show={showImageModal}
        onHide={handleCloseImageModal}
        centered
        size="xl"
        className="ImagePreviewModal"
      >
        {/* Top Right Close Button */}
        <Modal.Header closeButton />
        <Modal.Body className="text-center">
          {previewImage && (
            <img
              src={previewImage}
              alt="Preview"
              className="full_preview_img"
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ViewOffCanvance;
